/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = RepairOrderQuote
 *
 * 1 = CheckIn
 *
 * 2 = CheckOut
 *
 * 3 = LoanCheckIn
 *
 * 4 = LoanCheckOut
 */
export enum EmailDeliveryOptionEnum {
  RepairOrderQuote = 0,
  CheckIn = 1,
  CheckOut = 2,
  LoanCheckIn = 3,
  LoanCheckOut = 4,
}
